export default __webpack_public_path__ + "static/media/visa.1fae40ca.svg";